import http from "./_http";
import { resolve, Resolved } from "./_resolve";

const baseUrlPath = "/api/role/";

export async function getAll(): Promise<Resolved> {
  return await resolve(http.get(baseUrlPath));
}
